import React, { useState } from "react";

export default function InputNumber({ initialValue = 1, onConfirm }) {
  const [inputValue, setInputValue] = React.useState(initialValue);

  const handleDigitClick = (digit) => {
    setInputValue((prev) => {
      if (prev === 0 || prev === -1) return digit;
      return Number(String(prev) + String(digit));
    });
  };

  const handleClear = () => {
    setInputValue(0);
  };

  const handleDelete = () => {
    setInputValue((prev) => {
      if (prev === 0 || prev === -1) return 0;
      const str = String(prev);
      if (str.length === 1) return 0;
      return Number(str.slice(0, -1));
    });
  };

  const handleOk = () => {
    const finalValue = inputValue === -1 ? 0 : inputValue;
    if (onConfirm) onConfirm(finalValue);
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "12px",
        maxWidth: "320px",
        margin: "0 auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
      }}
    >
      {/* Отображение текущего значения */}
      <div
        style={{
          fontSize: "2.5rem",
          textAlign: "center",
          marginBottom: "24px",
          fontFamily: 'monospace',
          letterSpacing: '2px',
          padding: "16px",
          background: "#f8f9fa",
          borderRadius: "8px",
          border: "2px solid #e9ecef",
          minHeight: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {inputValue === -1 ? "0" : inputValue}
      </div>
      {/* Кнопки калькулятора */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "12px",
        marginBottom: "20px"
      }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((digit) => (
          <button
            key={digit}
            onClick={() => handleDigitClick(digit)}
            style={{
              padding: "20px",
              fontSize: "1.8rem",
              backgroundColor: "#f8f9fa",
              border: "2px solid #dee2e6",
              borderRadius: "10px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              fontWeight: "600",
              minHeight: "60px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
            }}
            onMouseDown={(e) => e.target.style.backgroundColor = "#e9ecef"}
            onMouseUp={(e) => e.target.style.backgroundColor = "#f8f9fa"}
            onMouseLeave={(e) => e.target.style.backgroundColor = "#f8f9fa"}
          >
            {digit}
          </button>
        ))}
      </div>
      {/* Кнопки CLR, DEL и OK */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "12px"
        }}
      >
        <button
          onClick={handleClear}
          style={{
            padding: "18px",
            fontSize: "1.2rem",
            backgroundColor: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "700",
            minHeight: "56px",
            boxShadow: "0 2px 4px rgba(220, 53, 69, 0.3)",
            transition: "all 0.2s ease"
          }}
          onMouseDown={(e) => e.target.style.backgroundColor = "#c82333"}
          onMouseUp={(e) => e.target.style.backgroundColor = "#dc3545"}
          onMouseLeave={(e) => e.target.style.backgroundColor = "#dc3545"}
        >
          CLR
        </button>
        <button
          onClick={handleDelete}
          style={{
            padding: "18px",
            fontSize: "1.2rem",
            backgroundColor: "#fd7e14",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "700",
            minHeight: "56px",
            boxShadow: "0 2px 4px rgba(253, 126, 20, 0.3)",
            transition: "all 0.2s ease"
          }}
          onMouseDown={(e) => e.target.style.backgroundColor = "#e55a00"}
          onMouseUp={(e) => e.target.style.backgroundColor = "#fd7e14"}
          onMouseLeave={(e) => e.target.style.backgroundColor = "#fd7e14"}
        >
          DEL
        </button>
        <button
          onClick={handleOk}
          style={{
            padding: "18px",
            fontSize: "1.2rem",
            backgroundColor: "#198754",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "700",
            minHeight: "56px",
            boxShadow: "0 2px 4px rgba(25, 135, 84, 0.3)",
            transition: "all 0.2s ease"
          }}
          onMouseDown={(e) => e.target.style.backgroundColor = "#146c43"}
          onMouseUp={(e) => e.target.style.backgroundColor = "#198754"}
          onMouseLeave={(e) => e.target.style.backgroundColor = "#198754"}
        >
          OK
        </button>
      </div>
    </div>
  );
};
